import { render, staticRenderFns } from "./IndexBdc.vue?vue&type=template&id=18cadb28&scoped=true&"
import script from "./IndexBdc.vue?vue&type=script&lang=js&"
export * from "./IndexBdc.vue?vue&type=script&lang=js&"
import style0 from "./IndexBdc.vue?vue&type=style&index=0&id=18cadb28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cadb28",
  null
  
)

export default component.exports